<div class="collab-notes">

  <!-- New Note Input -->
  <div class="note-input-area" [formGroup]="noteForm">
    <mat-form-field appearance="outline" style="width:100%">
      <mat-label>Add a note... (use @username to mention)</mat-label>
      <textarea matInput formControlName="notes" rows="3"
                placeholder="Type your note here. Mention teammates with @name"></textarea>
    </mat-form-field>
    <div fxLayout="row" fxLayoutAlign="end center" style="margin-top:4px">
      <button mat-raised-button color="primary"
              [disabled]="noteForm.invalid || saving"
              (click)="submitNote()">
        <mat-spinner *ngIf="saving" diameter="18" style="display:inline-block"></mat-spinner>
        <span *ngIf="!saving">Post Note</span>
      </button>
    </div>
  </div>

  <mat-divider style="margin: 16px 0"></mat-divider>

  <!-- Notes Feed -->
  <div class="notes-feed">
    <div *ngFor="let note of notes; trackBy: trackByNoteId" class="note-card">

      <!-- Note Header -->
      <div fxLayout="row" fxLayoutAlign="space-between center" class="note-header">
        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
          <div class="avatar">{{ (note.createdBy || 'U')[0].toUpperCase() }}</div>
          <div>
            <span class="author-name">{{ note.createdBy }}</span>
            <span class="note-time">{{ note.createdDate | date:'dd MMM yyyy, h:mm a' }}</span>
          </div>
          <span class="note-type-badge">{{ note.noteType }}</span>
        </div>
        <button mat-icon-button [matMenuTriggerFor]="noteMenu">
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #noteMenu="matMenu">
          <button mat-menu-item (click)="startReply(note.noteId)">
            <mat-icon>reply</mat-icon> Reply
          </button>
          <button mat-menu-item (click)="deleteNote(note.noteId)"
                  *ngIf="note.createdBy === currentUser?.name">
            <mat-icon>delete</mat-icon> Delete
          </button>
        </mat-menu>
      </div>

      <!-- Note Body -->
      <p class="note-body" [innerHTML]="note.notes | mentionHighlight"></p>

      <!-- Reply toggle -->
      <div class="reply-actions" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="12px">
        <button mat-button class="reply-toggle" (click)="loadReplies(note.noteId)">
          <mat-icon>chat_bubble_outline</mat-icon>
          {{ repliesMap[note.noteId] ? 'Hide' : 'View' }} Replies
        </button>
        <button mat-button (click)="startReply(note.noteId)">
          <mat-icon>reply</mat-icon> Reply
        </button>
      </div>

      <!-- Inline Reply Form -->
      <div *ngIf="replyingTo === note.noteId" class="reply-form" [formGroup]="replyForm">
        <mat-form-field appearance="outline" style="width:100%">
          <mat-label>Write a reply...</mat-label>
          <textarea matInput formControlName="notes" rows="2"></textarea>
        </mat-form-field>
        <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="8px">
          <button mat-stroked-button (click)="cancelReply()">Cancel</button>
          <button mat-raised-button color="primary"
                  [disabled]="replyForm.invalid || saving"
                  (click)="submitReply(note.noteId)">
            <mat-spinner *ngIf="saving" diameter="16" style="display:inline-block"></mat-spinner>
            <span *ngIf="!saving">Post Reply</span>
          </button>
        </div>
      </div>

      <!-- Replies -->
      <div *ngIf="repliesMap[note.noteId]" class="replies-container">
        <div *ngFor="let reply of repliesMap[note.noteId]" class="reply-card">
          <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
            <div class="avatar avatar-sm">{{ (reply.createdBy || 'U')[0].toUpperCase() }}</div>
            <div>
              <span class="author-name">{{ reply.createdBy }}</span>
              <span class="note-time">{{ reply.createdDate | date:'dd MMM, h:mm a' }}</span>
            </div>
          </div>
          <p class="note-body">{{ reply.notes }}</p>
        </div>
      </div>

    </div><!-- /note-card -->
  </div><!-- /notes-feed -->

  <!-- Load More -->
  <div *ngIf="page + 1 < totalPages" fxLayoutAlign="center center" style="margin-top:12px">
    <button mat-stroked-button (click)="loadMore()">Load more notes</button>
  </div>

  <div *ngIf="notes.length === 0" class="empty-state">
    <mat-icon>notes</mat-icon>
    <p>No notes yet. Be the first to add one!</p>
  </div>

</div>
